// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, message } from 'antd';
import AppHeader from './components/header'; // 修正路径
import AppFooter from './components/footer'; // 修正路径
import Home from './pages/Home';
import Archive from './pages/Archive';
import About from './pages/About';
import Auth from './pages/Auth';
import WritePost from './pages/WritePost';
import PostDetail from './pages/PostDetail';
import NotFound from './pages/NotFound';
import { getRecentPosts, getArchivePosts, getPostById, createPost, updatePost, getAboutInfo, updateAboutInfo } from './api/mockData'; // 修正API导入
import './App.css';

const { Content } = Layout;

function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [aboutInfo, setAboutInfo] = useState({
    name: '张三',
    avatar: '/default-avatar.png',
    intro: '前端开发者，热爱技术分享',
    details: '欢迎来到我的博客！',
    email: 'zhangsan@example.com',
    techStack: 'React, JavaScript, Node.js',
    hobbies: '阅读、旅行、摄影',
    github: 'https://github.com/zhangsan',
    personalHomepage: 'https://zhangsan.com'
  });

  // 页面加载时检查本地存储的登录状态
  useEffect(() => {
    const storedUser = localStorage.getItem('loggedInUser');
    if (storedUser) {
      setLoggedInUser(JSON.parse(storedUser));
    }
    
    // 也可以考虑从本地存储加载aboutInfo
    const storedAboutInfo = localStorage.getItem('aboutInfo');
    if (storedAboutInfo) {
      setAboutInfo(JSON.parse(storedAboutInfo));
    }
  }, []);

  const handleLogin = async (credentials) => {
    // 模拟登录逻辑
    if (credentials.username === 'admin' && credentials.password === 'password') {
      const user = { username: 'admin', id: 1 };
      setLoggedInUser(user);
      localStorage.setItem('loggedInUser', JSON.stringify(user)); // 存储登录状态
      message.success('登录成功');
      return { success: true };
    }
    message.error('用户名或密码错误');
    return { success: false, message: '用户名或密码错误' };
  };

  const handleRegister = async (userData) => {
    // 模拟注册逻辑
    console.log('注册用户:', userData);
    message.success('注册成功，请登录');
    return { success: true, message: '注册成功' };
  };

  const handleLogout = () => {
    setLoggedInUser(null);
    localStorage.removeItem('loggedInUser'); // 移除登录状态
    message.success('已退出登录');
  };

  const handleUpdateAboutInfo = (newInfo) => {
    setAboutInfo(prev => ({ ...prev, ...newInfo }));
    localStorage.setItem('aboutInfo', JSON.stringify({...aboutInfo, ...newInfo})); // 存储更新的信息
    message.success('个人信息更新成功');
  };

  return (
    <Router>
      <Layout className="blog-layout">
        <AppHeader loggedInUser={loggedInUser} onLogout={handleLogout}/>
        
        <Content className="app-content">
          <Routes>
            <Route path="/" element={
              <Home 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="/archive" element={
              <Archive 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="/about" element={
              <About 
                aboutInfo={aboutInfo} 
                onUpdateAboutInfo={handleUpdateAboutInfo}
                loggedInUser={loggedInUser}
                onLogout={handleLogout}
              />
            } />
            <Route path="/auth" element={
              <Auth 
                onLogin={handleLogin}
                onRegister={handleRegister}
                loggedInUser={loggedInUser}
                onLogout={handleLogout}
              />
            } />
            <Route path="/write" element={
              loggedInUser ? (
                <WritePost 
                  loggedInUser={loggedInUser} 
                  onLogout={handleLogout}
                />
              ) : (
                <Navigate to="/auth" />
              )
            } />
            <Route path="/post/:id" element={
              <PostDetail 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="/notfound" element={
              <NotFound 
                loggedInUser={loggedInUser} 
                onLogout={handleLogout} 
              />
            } />
            <Route path="*" element={<Navigate to="/notfound" />} />
          </Routes>
        </Content>
        
        <AppFooter />
      </Layout>
    </Router>
  );
}

export default App;